import React from 'react';
import NotificationCardEngine from '../../../components/notification/engine/NotificationCardEngine';
import EmailDialog, {
  EMAIL_DIALOG_TYPES
} from '../../../components/engine/EmailDialogEngine';
import Search from '../../../components/engine/SearchEngine';
import styled from 'styled-components/macro';
import { TextString } from '../../../components/Text';

const CardsContainer = styled.div`
  background-color: #fff;
  margin: 1rem auto;
  position: relative;
  width: 1060px;
`;

const SearchContainer = styled.div`
  padding: 0.8em;
`;

const NoResults = styled.div`
  margin-top: 0.8em;
`;

const getAdditionalPlaceHolders = allFields => {
  const additionalPlaceHolders = allFields.map(field => ({
    value: field.internalId,
    text: field.title || `Untitled ${field.uiType} field`,
    'data-testid': `placeholder-field-${field.internalId}`
  }));
  additionalPlaceHolders.push({
    value: 'referenceId',
    text: 'referenceId',
    'data-testid': `placeholder-field-child.referenceId`
  });
  return additionalPlaceHolders;
};

const FormBuilderNotificationsView = ({
  formId,
  emailTemplates,
  onClickedEdit,
  onSetActive,
  isEmailDialogOpen,
  searchValue,
  loadEmailTemplates,
  setIsEmailDialogOpen,
  setSearchValue,
  templateId,
  templateCode,
  filteredTemplates,
  allFields,
  ...props
}) => {
  return (
    <>
      <CardsContainer>
        {emailTemplates && emailTemplates.length > 0 && (
          <SearchContainer>
            <Search onSearch={setSearchValue} />
          </SearchContainer>
        )}
        {filteredTemplates.length ? (
          filteredTemplates.map(one => (
            <NotificationCardEngine
              key={one.id}
              notificationData={one}
              onClickedEdit={onClickedEdit}
              onToggleChange={onSetActive}
              onDisabledToggleClicked={() => {}}
            />
          ))
        ) : searchValue ? (
          <NoResults>
            <TextString content="form-builder.labels.no_results" />
          </NoResults>
        ) : (
          ''
        )}
      </CardsContainer>
      <EmailDialog
        open={isEmailDialogOpen}
        handleConfirm={() => {
          loadEmailTemplates();
        }}
        handleClose={() => setIsEmailDialogOpen(false)}
        type={EMAIL_DIALOG_TYPES.TEMPLATE}
        templateId={templateId}
        assetId={formId}
        assetType="forms"
        templateCode={templateCode}
        additionalPlaceHolders={
          !props.showFieldPlaceholderDropdown
            ? []
            : getAdditionalPlaceHolders(allFields)
        }
        additionalPlaceHoldersProps={{
          placeholder: 'Insert field placeholder'
        }}
      />
    </>
  );
};

export default FormBuilderNotificationsView;
